import { c as _c } from "react/compiler-runtime";
import PlanCard from "./PlanCard";
import { PLANS } from "./data";
const Pricing = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="text-[13px] font-semibold uppercase leading-[21px] tracking-wide text-[#6a6d75]">Pricing</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <header className="mx-auto flex max-w-[680px] flex-col items-center gap-3 text-center">{t0}<h2 className="break-keep font-[family-name:var(--font-nanum-square-neo)] text-[32px] font-extrabold leading-[1.35] tracking-[-1px] text-[#121212] sm:text-[40px] lg:text-[44px] lg:tracking-[-1.26px]"><span className="font-black text-[#7a33ff]">병원 규모</span><span>에 맞는 요금제</span></h2><p className="break-keep text-[16px] leading-[27px] text-[#121212] sm:text-[16.5px]">모든 요금제는 월 단위이며 약정 없이 시작할 수 있습니다.</p></header>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section id="pricing" className="w-full bg-[#f6f7f9] py-16 lg:py-20"><div className="mx-auto w-full max-w-[1140px] px-5 lg:px-0">{t1}<div className="mt-8 grid grid-cols-1 items-stretch gap-5 lg:mt-10 lg:grid-cols-3">{PLANS.map(_temp)}</div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Pricing;
function _temp(plan) {
  return <PlanCard key={plan.id} plan={plan} />;
}